<h2 mat-dialog-title>User Info</h2>
<mat-dialog-content>
    <mat-form-field class="w-100">
        <mat-label>Name</mat-label>
        <input matInput [value]="data?.name" disabled />
    </mat-form-field>
    <mat-form-field class="w-100">
        <mat-label>Phone</mat-label>
        <input matInput [value]="data?.phoneNumber" disabled />
    </mat-form-field>
    <mat-form-field class="w-100">
        <mat-label>Email</mat-label>
        <input matInput [value]="data?.email" disabled />
    </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button (click)="verify()">Verify</button>
</mat-dialog-actions>